export default "__VITE_ASSET__RDjFgTgG__"